import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { VivaBackButtonComponent } from './viva-back-button.component';

@NgModule({
  declarations: [VivaBackButtonComponent],
  imports: [CommonModule, IonicModule, TranslatePipe, TranslateDirective],
  exports: [VivaBackButtonComponent],
})
export class VivaBackButtonModule {}
